import gql from 'graphql-tag';

export default gql`
  mutation CreateEatery(
    $data: EateryCreateInput!
  ) {
    createEatery(
      data: $data
    ) {
      id
      name
      status
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateEatery.ts